"use strict";
/**
 * The parts of the credit price list the buy screen renders but the server does not send.
 *
 * A copy, and a knowing one. `assistantCreditQuote` answers what a given amount buys — the
 * rate, the bonus it earns and the delivered credits all come from the server, so the promise
 * on screen and the credits Stripe grants cannot drift. What it does not answer is which
 * amounts to offer in the first place, and that is what lives here.
 *
 * The mirror of this file is `spec/assistantcredits.yaml` in the backend. Change one and the
 * other has to follow, or the badge on a tile will advertise a bonus the purchase does not pay.
 * The percentages are duplicated rather than derived for exactly that reason: deriving them
 * would mean reimplementing the price list's threshold rule here, and two implementations drift
 * more quietly than two constants.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.bonusCreditsIn = exports.TOPUP_VALIDITY_MONTHS = exports.TOPUP_OFFERS = void 0;
/** Ready-made amounts, ascending, in whole major units of the organization's currency. */
exports.TOPUP_OFFERS = [
    // Below the first bonus threshold on purpose — the cheapest offer is there to be
    // affordable, not to earn anything.
    { amount: 200, percent: 0 },
    { amount: 500, percent: 10 },
    { amount: 1500, percent: 20 },
    { amount: 2500, percent: 30 },
];
/** `core.assistant.topupValidityMonths`. Stated on the buy screen as a term of the sale. */
exports.TOPUP_VALIDITY_MONTHS = 12;
/**
 * The part of a quote's credits that the volume bonus added.
 *
 * Reversed out of the total rather than quoted, because the rate the server used is not in the
 * answer. Exact for the price list as written — every currency rate is a whole number of
 * credits per unit, so the base is whole and the division comes out even — and rounded rather
 * than floored so a future fractional rate degrades into an off-by-one rather than a visible
 * lie.
 */
const bonusCreditsIn = (credits, bonusPercent) => bonusPercent <= 0 ? 0 : credits - Math.round(credits / (1 + bonusPercent / 100));
exports.bonusCreditsIn = bonusCreditsIn;
